import { FC } from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import { WorkspaceFilterBy } from "@/apis/bacchus/workspace";

interface ProjectsToolbarProps {
  filterBy: WorkspaceFilterBy;
  onFilterByChange: (filterBy: WorkspaceFilterBy) => void;
}

export const ProjectsToolbar: FC<ProjectsToolbarProps> = ({
  filterBy,
  onFilterByChange,
}) => {
  const handleTabChange = (
    _event: React.SyntheticEvent,
    newValue: WorkspaceFilterBy
  ) => {
    onFilterByChange(newValue);
  };

  return (
    <Tabs value={filterBy} onChange={handleTabChange}>
      <Tab
        data-testid="workspace-filter-tab-my"
        label="My Projects"
        value="my"
      />
      <Tab
        data-testid="workspace-filter-tab-org"
        label="Organization"
        value="org"
      />
      <Tab data-testid="workspace-filter-tab-all" label="All" value="all" />
    </Tabs>
  );
};
